import * as React from 'react';
import {
  KeyboardService,
  slashHelpBinding,
} from 'lib/services/keyboard-service';
import { TouchUpEditorModal } from 'samosa/models/touchup-editor-modal';

export function useVocabKeyboardBindings(
  editor: TouchUpEditorModal,
  onResolve: (value: boolean) => void
) {
  React.useEffect(() => {
    return KeyboardService.instance.addShortcutSet('editor', {
      down: [() => editor.moveToNextLine(), null], // 'Next line'],
      up: [() => editor.moveToPrevLine(), null], //'Previous line'],
      // left: [() => editor.moveToPrevAlert(), 'Previous alert'],
      // j: [() => editor.moveToPrevAlert(), null],
      left: [() => editor.moveToPrevAlert(), 'Previous alert'],
      j: [() => editor.moveToPrevAlert(), null],
      right: [() => editor.moveToNextAlert(), 'Next alert'],
      k: [() => editor.moveToNextAlert(), null],
      s: [() => editor.suppressAlertsForCurrent(), 'Suppress alert'],

      enter: [() => editor.handleEditIntent(), 'Edit vocab'],
      a: [() => editor.handleAddVocab(), 'Add free-form vocab'],
      // 'shift+enter': [() => editor.handleEditIntent(), 'Edit vocab'],
      'ctrl+d': [() => editor.toggleArchive(), 'Archive (soft delete) vocab'],
      'shift+ctrl+d': [
        () => editor.toggleShowArchived(),
        'Show / hide archived',
      ],

      f: [
        () => editor.markPending(),
        'Flag (to be addressed before sending back to Script Editor)',
      ],
      l: [
        () => editor.markDeferred(),
        'Defer (note will be sent back to Script Editor as comment)',
      ],
      r: [
        () => editor.markResolved(),
        'Resolve (clears flagged / deferred state)',
      ],
      'shift+s': [() => editor.saveToMasala(), 'Save to Masala'],
      m: [() => editor.handleMoveVocab(), 'Move vocab to another line'],
      n: [() => editor.editNote(), 'Add/edit note (automatically flags)'],
      'shift+n': [() => editor.toggleShowNotes(), 'Show / hide notes'],
      space: [() => editor.handlePlayAction(), 'Play/stop playing'],
      b: [() => editor.handleRewindAction(), 'Rewind 5 seconds'],
      escape: [
        () => {
          onResolve(undefined);
        },
        null,
      ],
      'shift+slash, slash': [() => KeyboardService.instance.toggleHelp(), null],
    });

    // KeyboardService.instance.setCurrentShortcutSet('editor');
    // return () => {
    //   KeyboardService.instance.removeShortcutSet('editor');
    // };
  }, [editor, onResolve]);

  // for (const [key, value] of Object.entries(bindings)) {
  //   useKeyboardBinding(key, value);
  // }
}
